// extracted by mini-css-extract-plugin
module.exports = {"primary":"#f3bf38","secondary":"#ff873f","textMuted":"rgba(0, 0, 0, 0.6)"};